import React from "react";
import styled from "styled-components";

export const Subtitle = styled((props) => <h4 {...props} />).attrs((props) => ({
  automationid:
    props.automationid ||
    `SalesLead_h4_${props?.automationidattr?.replace(/ /g, "")}_1"`,
}))`
  font-size: 20px;
  font-weight: 500;
  color: ${(props) => (props.color ? props.color : "#282828")};
  line-height: 1.6;
  margin-bottom: 0 !important;
  margin-top: ${(props) => props.marginTop || "1.75rem"};
  margin-bottom: 1.75rem;
  text-align: ${(props) => props.aligntext || "left"};
  font-family: "Roboto";
`;
